import React from "react";
const OverallLoadingTable = ({ data }) => {
  const cmtWagons = [
    ...new Set(
      data
        .filter((f) => f.commodity === "CEMT")
        .map((m) => {
          return `${m.commodity} / ${m.wagonType}`;
        }),
    ),
  ];
  const otherWagons = [
    ...new Set(
      data
        .filter((f) => f.commodity !== "CEMT")
        .map((m) => {
          return `${m.commodity} / ${m.wagonType}`;
        }),
    ),
  ];
  const totalCemt = data
    .filter((f) => f.commodity === "CEMT")
    .reduce(
      (acc, item) => {
        acc.wagon += item.count || 0;
        acc.rake += item.wagonCount || 0;
        return acc;
      },
      { wagon: 0, rake: 0 },
    );
  const total = data.reduce(
    (acc, item) => {
      acc.wagon += item.count || 0;
      acc.rake += item.wagonCount || 0;
      return acc;
    },
    { wagon: 0, rake: 0 },
  );
  const totalOther = data
    .filter((f) => f.commodity !== "CEMT")
    .reduce(
      (acc, item) => {
        acc.wagon += item.count || 0;
        acc.rake += item.wagonCount || 0;
        return acc;
      },
      { wagon: 0, rake: 0 },
    );

  // { wagon: 120, rake: 45 }
  return (
    <div>
      {" "}
      <div className="card-body bg-light">
        <div className="table-responsive newUiTable">
          <table className="table">
            <thead className="align-middle">
              <tr>
                <th
                  className="border-end"
                  colSpan={cmtWagons.length > 0 ? cmtWagons.length + 1 : 1}
                  rowSpan={cmtWagons.length === 0 && 0}
                >
                  CEMENT
                </th>

                <th
                  className="border-end"
                  colSpan={otherWagons.length > 0 ? otherWagons.length + 1 : 1}
                  rowSpan={otherWagons.length === 0 && 0}
                >
                  OTHER THEN CEMENT
                </th>
                <th rowSpan={2}>GRAND TOTAL</th>
              </tr>
              <tr>
                {cmtWagons.map((m, j) => {
                  return <th key={j}>{m}</th>;
                })}{" "}
                {cmtWagons.length > 0 && <th className="border-end">Total</th>}
                {otherWagons.map((m, k) => {
                  return <th key={k}>{m}</th>;
                })}
                {otherWagons.length > 0 && (
                  <th className="border-end">Total</th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr>
                {cmtWagons.map((m, j) => {
                  const str = m;
                  const arr = str.split("/").map((item) => item.trim());

                  return (
                    <td className="px-3 fw-bold text-dark" key={j}>
                      {data.find((f) => {
                        return f.commodity === arr[0] && f.wagonType === arr[1];
                      }).count || 0}
                    </td>
                  );
                })}{" "}
                <td className="px-3 fw-bold text-dark border-end">
                  {totalCemt.wagon || 0}
                </td>
                {otherWagons.map((m, k) => {
                  const str = m;
                  const arr = str.split("/").map((item) => item.trim());
                  return (
                    <td className="px-3 fw-bold text-dark" key={k}>
                      {data.find((f) => {
                        return f.commodity === arr[0] && f.wagonType === arr[1];
                      }).count || 0}
                    </td>
                  );
                })}
                <td className="px-3 fw-bold text-dark border-end">
                  {totalOther.wagon || 0}
                </td>
                <td className="px-3 fw-bold text-dark"> {total.wagon || 0}</td>
              </tr>{" "}
              <tr>
                {cmtWagons.map((m, j) => {
                  const str = m;
                  const arr = str.split("/").map((item) => item.trim());

                  return (
                    <td className="px-3 fw-bold text-dark" key={j}>
                      {data.find((f) => {
                        return f.commodity === arr[0] && f.wagonType === arr[1];
                      }).wagonCount || 0}
                    </td>
                  );
                })}{" "}
                <td className="px-3 fw-bold text-dark border-end">
                  {totalCemt.rake || 0}
                </td>
                {otherWagons.map((m, k) => {
                  const str = m;
                  const arr = str.split("/").map((item) => item.trim());
                  return (
                    <td className="px-3 fw-bold text-dark" key={k}>
                      {data.find((f) => {
                        return f.commodity === arr[0] && f.wagonType === arr[1];
                      }).wagonCount || 0}
                    </td>
                  );
                })}
                <td className="px-3 fw-bold text-dark border-end">
                  {totalOther.rake || 0}
                </td>
                <td className="px-3 fw-bold text-dark"> {total.rake || 0}</td>
              </tr>{" "}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default OverallLoadingTable;
